<template>
  <label
    :for="inputId"
    class="switcher justify-space-between"
    tabindex="0"
    @keyup.enter="$emit('change')"
  >
    <div v-if="switcherText" class="switcher__text">{{ switcherText }}</div>
    <div v-if="switcherTextStart" class="switcher__text switcher__text-start">
      {{ switcherTextStart }}
    </div>
    <div class="switcher__toggle m-0">
      <input
        type="checkbox"
        :id="inputId"
        class="switcher__toggle-input not-empty"
        :checked="ifChecked"
        @change="$emit('change')"
        tabindex="0"
      />
      <div class="switcher__toggle-marker"></div>
    </div>
    <div v-if="switcherTextEnd" class="switcher__text switcher__text-end">
      {{ switcherTextEnd }}
    </div>
  </label>
</template>

<script>
export default {
  name: 'Switcher',
  props: {
    ifChecked: {
      type: [Boolean, Number],
      required: true
    },
    inputId: {
      default: 'switcher-' + Math.ceil(Math.random() * 1000000)
    },
    switcherTextStart: {
      default: false
    },
    switcherTextEnd: {
      default: false
    },
    switcherText: {
      default: false
    }
  }
};
</script>

<style scoped></style>
